const DEFAULT_COLOR: string = "hsl(0, 100%, 50%)";

export { DEFAULT_COLOR };
